@if (form()) {
  <gplus-autocomplete
    class="mb-6"
    filteredBy="description"
    attrVef="form-create-manual-carrier"
    [attrVefItem]="'form-create-manual-dropdown-item'"
    labelType="carrier"
    [control]="form().controls['carrierEdited']"
    [data]="carrierList()"
    [label]="'FormTJCreationCarrier' | translate"
    [disabled]="form().controls['carrierEdited']?.status === 'DISABLED'"
    [placeholder]="'FormTJCreationCarrierPlaceholder' | translate"
    [hideAssistiveOnNull]="true"
    [validations]="{
      notClearable: 'EditTherapyJobParamCannotClear' | translate
    }"
  />

  <div class="group">
    <gplus-input
      type="text"
      [control]="form().controls['totalVolumeEdited']"
      [label]="'FormTJCreationVolume' | translate"
      [disabled]="form().controls['totalVolumeEdited']?.status === 'DISABLED'"
      [placeholder]="'FormTJCreationVolumePlaceholder' | translate"
      [attrVef]="'form-create-manual-volume'"
      [measure]="'UnitMl' | translate"
      [formatAsNumber]="true"
      [validations]="{
        notNumber: 'FormTJCreationNotNumber' | translate,
        notPositive: 'FormTJCreationMinLimit' | translate,
        notInteger: 'FormTJCreationOnlyIntegers' | translate,
        notClearable: 'EditTherapyJobParamCannotClear' | translate,
        max: 'FormTJCreationMaxLimit9999' | translate
      }"
    />

    <gplus-input
      type="text"
      [control]="form().controls['flowRatePlannedEdited']"
      [label]="'FormTJCreationFlowRate' | translate"
      [disabled]="form().controls['flowRatePlannedEdited']?.status === 'DISABLED'"
      [placeholder]="'FormTJCreationFlowRatePlaceholder' | translate"
      [attrVef]="'form-create-manual-flowrate'"
      [measure]="'UnitMlHr' | translate"
      [formatAsNumber]="true"
      [validations]="{
        notNumber: 'FormTJCreationNotNumber' | translate,
        notPositive: 'FormTJCreationMinLimit' | translate,
        notInteger: 'FormTJCreationOnlyIntegers' | translate,
        notClearable: 'EditTherapyJobParamCannotClear' | translate,
        max: 'FormTJCreationMaxLimit999' | translate
      }"
    />
  </div>
}

<div class="actions-btns">
  <cw-button button-color="secondary" variant="outlined" (click)="closeDialog()">
    {{ 'EditPreparationTimeCancelBtn' | translate }}
  </cw-button>

  @if (saveState() === SaveState.DISABLED) {
    <!-- Disabled -->
    <cw-tooltip [content]="saveTooltipKey() | translate" placement="bottom">
      <cw-button
        data-test="prepared-time-submit-btn"
        button-color="accent"
        variant="filled"
        [disabled]="true"
        type="submit"
      >
        {{ 'EditTherapyJobParamsSave' | translate }}
      </cw-button>
    </cw-tooltip>
  } @else {
    <!-- Enabled -->
    <cw-button
      data-test="prepared-time-submit-btn"
      button-color="accent"
      variant="filled"
      (click)="submit()"
      type="submit"
    >
      {{ 'EditTherapyJobParamsSave' | translate }}
    </cw-button>
  }
</div>
